import { bowser, serviceClient } from '@yola/ws-sdk';
import generateUnsplashBackLink from '../helpers/generate-unsplash-back-link';
import createPhotoItem from '../helpers/create-photo-item';
import { GALLERY_ITEMS_BATCH_SIZE } from '../constants/common';
import stockLabels from '../constants/stock-labels';

function createUnsplashApiAdapter() {
  const { unsplashListPhotos, unsplashSearchPhotos } = serviceClient.get();
  const isMobile = bowser.mobile;

  const normalizeData = (data) => {
    if (Array.isArray(data)) {
      return data;
    }

    if (data && data.results && Array.isArray(data.results)) {
      return data.results;
    }

    return [];
  };

  const getComputedData = (data) => {
    const normalizedData = normalizeData(data);
    return normalizedData.map(({ id, urls, width, height, altDescription, user, links }) =>
      createPhotoItem({
        id,
        src: isMobile ? urls.small : urls.regular,
        width,
        height,
        alt: altDescription,
        info: {
          authorName: user.name,
          authorLink: generateUnsplashBackLink(user.links.html),
          stockLink: generateUnsplashBackLink(links.html),
          stockName: stockLabels.UNSPLASH,
        },
      })
    );
  };

  const getInitialPhotos = async (params = {}) => {
    const { query, abortController } = params;

    if (query) {
      return unsplashSearchPhotos(
        {
          per_page: GALLERY_ITEMS_BATCH_SIZE,
          query,
        },
        { ...(abortController && { abortController }) }
      );
    }

    return unsplashListPhotos(
      {
        per_page: GALLERY_ITEMS_BATCH_SIZE,
      },
      { ...(abortController && { abortController }) }
    );
  };

  const searchPhotos = async (params = {}) => {
    const { query, perPage = GALLERY_ITEMS_BATCH_SIZE, abortController } = params;

    return unsplashSearchPhotos(
      {
        per_page: perPage,
        query,
      },
      { ...(abortController && { abortController }) }
    );
  };

  const getPhotos = (params = {}) => {
    const { perPage = GALLERY_ITEMS_BATCH_SIZE, abortController } = params;

    return unsplashListPhotos(
      {
        per_page: perPage,
      },
      { ...(abortController && { abortController }) }
    );
  };

  return {
    getInitialPhotos,
    searchPhotos,
    getPhotos,
    getComputedData,
  };
}

export default createUnsplashApiAdapter;
